import React from 'react';
import './About.css';

function About() {
  return (
    <section id="about" className="about">
      <h2>About Me</h2>
      {/* <p>Hello! I'm  Ravini Kuruppu, an undergraduate.</p> */}
      <p>I am an ambitious undergraduate student with a deep passion for technology and a firm belief in its potential to create a better world. My enthusiasm for mathematics and computer science has guided me to pursue a degree in Computer Science and Engineering.
      I aim to leverage my industrial placements to expand my expertise, sharpen my skills, and contribute meaningfully to societal advancement through the transformative power of technology.
      </p>

      {/* <p>My academic journey in computer science and engineering combines a strong theoretical foundation with opportunities for innovation, allowing me to explore beyond established concepts. This has fueled my eagerness to translate my knowledge into real-world applications and gain hands-on experience in industry settings.</p>

      <p>I aim to leverage my industrial placements to expand my expertise, sharpen my skills, and contribute meaningfully to societal advancement through the transformative power of technology.</p> */}

      <p className='paragraph'>Areas of Interest: Software Engineering, Web Development, Mobile App Development, Mathematics</p>
    </section>
  );
}

export default About;
